import {Entity, Cartesian3, PropertyBag, CallbackProperty} from 'cesium';
import {Label as getLabelStyle, Marker as getStyle, setEntityStyle} from '../renderer';
import SuperGif from 'libgif';

export default class Marker extends Entity {
    constructor(options) {
        const {geometry, properties, style, label, ...other} = options;
        let props = {
            clampToGround: true,
            position: Cartesian3.fromDegrees(...geometry),
            properties: new PropertyBag(properties),
            billboard: {
                ...getStyle({...style}),
            },
            ...other,
        };

        // 添加label
        if (label?.text) {
            props.label = getLabelStyle(label);
        }

        super(props);

        this.geometry = geometry;

        if (style?.image && style?.imageType) {
            const {imageType, image, imageKey} = style;
            if (imageType === 'gif') {
                this.setGifImage(image, imageKey);
            }
        }
    }

    // 设置 gif 图标
    setGifImage(image, imageKey) {
        let gifDiv = document.createElement('div')
        let gifImg = document.createElement('img')

        // gif库需要img标签配置下面两个属性
        gifImg.setAttribute('rel:animated_src', image)
        gifImg.setAttribute('rel:auto_play', '1') // 设置自动播放属性
        gifDiv.appendChild(gifImg)

        let superGif = new SuperGif({
            gif: gifImg
        });

        window.gifImages = window.gifImages || {};
        window.gifImages[imageKey] = superGif;

        // 解析gif每帧图片，按时间序列进行切换
        superGif.load(() => {
            this.billboard.image = new CallbackProperty(() => {
                return superGif.get_canvas().toDataURL()
            }, false)
        })
    }

    setGeometry(geometry) {
        this.position.setValue(Cartesian3.fromDegrees(...geometry));
    }

    setProperties(properties) {
        this.properties.setValue(new PropertyBag(properties));
    }

    getProperties() {
        return this.properties;
    }

    setLabel(label) {
        this.label.setValue(getLabelStyle(label))
    }

    setStyle(style) {
        setEntityStyle(this.billboard, getStyle({...style}));
    }
}
